import { FC, useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Modal from "@app/shared/Modals/Modal";
import ExceptionsService from "./exceptionsService";
import { ExceptionsFiltersContext } from "./contexts/ExceptionsFiltersContext";


interface ExpireModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  singleExceptionId?: number;
  resetSelectedCheckboxes: () => void;
}

const ExpireModal: FC<ExpireModalProps> = ({ isModalOpen, setIsModalOpen, singleExceptionId, resetSelectedCheckboxes }) => {
  const exceptionsService = useRef(new ExceptionsService()).current;
  const exceptionFilterContext = useContext(ExceptionsFiltersContext);
  const [bodyMessage, setBodyMessage] = useState<string>("");
  useEffect(() => {
    if (exceptionFilterContext.selectedExceptionIds.length == 1 || singleExceptionId) {
      setBodyMessage("1 exception has been selected to be expired. Do you wish to continue?");
    } else {
      setBodyMessage(`${exceptionFilterContext.selectedExceptionIds.length} exceptions have been selected to be expired. Do you wish to continue?`);
    }
  }, [exceptionFilterContext.selectedExceptionIds, singleExceptionId]);

  const handleConfirm = async () => {
    let successfullMessage = "";
    try {
      if (singleExceptionId) {
        await exceptionsService.expireSpecialtyGroupExceptions([singleExceptionId]);
        successfullMessage = "The selected exception has been successfully expired";
      } else {
        const selectedExceptionIds = exceptionFilterContext.selectedExceptionIds;
        await exceptionsService.expireSpecialtyGroupExceptions(selectedExceptionIds);
        successfullMessage = selectedExceptionIds.length > 1 ? "The selected exceptions have been successfully expired" : "The selected exception has been successfully expired";
      }
      toast(successfullMessage,
        {
          containerId: "z-index-9999",
          type: "success"
        }
      );
    }
    catch (error) {
      toast.error("There was an error expiring the exception(s).");
    }
    finally {
      exceptionFilterContext.setTriggerRefreshData(true);
      setIsModalOpen(false);
      resetSelectedCheckboxes();
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      closeModal={handleCloseModal}
      content={{
        body: (
          <div className="ps-3 pe-3 mb-3">
            {bodyMessage}
          </div>
        ),
        cancelButtonText: "Cancel",
        confirmButtonAction: handleConfirm,
        confirmButtonDisable: false,
        confirmButtonText: "Confirm",
        confirmButtonType: "primary",
        title: (singleExceptionId != undefined || exceptionFilterContext.selectedExceptionIds.length == 1) ? 'Expire Exception' : 'Expire Exceptions',
      }}
      isVisible={isModalOpen}
      hideBodyScroll={true}
    />
  );
};

export default ExpireModal;
